










import { Component, Vue, Prop } from 'vue-property-decorator';
import { State } from 'vuex-class';
import DeploymentsTable from './DeploymentsTable.vue';
import CreateDeployment from './CreateDeployment.vue';
import BulkUpgrade from './BulkUpgrade.vue';
import { Service } from '../../types';

@Component({
  name: 'deployments',
  components: {
    DeploymentsTable,
    CreateDeployment,
    BulkUpgrade
  }
})
export default class Deployments extends Vue {
  @Prop({ required: true, type: Object })
  service!: Service;

  onDeploymentCreated() {
    // @ts-ignore
    this.$refs.table.reset();
  }
}
